This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <!-- Container to keep the overflow nice and contained -->
  <section class="basicBlock psdBlock withBeam select-none" id="psdBlock">
    <!-- Drop area of the PSD -->
    <div id="psdDropZone" class="nested"></div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  name: "psd-block",
  props: {},
  mounted() {
    const sizeCheck = this.$store.getters.getLevelMakerAnswerBlocks.size > 0;
    if (window.location.pathname == "/docent/levelmaker" && sizeCheck) {
      let elem: HTMLElement | null = document.getElementById("psdDropZone");
      if (elem != null) {
        elem.innerHTML = this.$store.getters.getLevelMakerAnswerHTML;
      }
    }
  },
})
export default class PSDblock extends Vue {}
</script>
